import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M18.8 221.7c0-67.9 73-100.2 126.8-69.2 18.8 0 37.3-5 54.5-11.8v50.5c-6.5 2.2-13 4-19.7 5.5 2.5 6.8 4 13.7 4 21 0 42.2-26 74.5-67.5 82.2-12.5 2.6-19.7 7.8-19.7 21.3 0 38.3 101 12.3 101 82.8 0 57.3-38.7 76-90.7 76-42.7 0-91.5-14.3-91.5-65.8 0-29.9 18-47.2 45.3-56.2v-1c-25-15.2-19.8-57.5-1-65.8v-1c-25.3-8.5-41.5-43.2-41.5-68.5zM106.5 385.5c-17.7 0-39.7 3.8-39.8 26.1 0 22.5 26 25.2 43.3 25.2 18.2 0 37.7-4.5 37.7-26.3 0-22-24.2-25-41.2-25zM103.3 256c21.7 0 29.7-14 29.7-34.3 0-48.3-61-48.8-61 0.5 0 20.8 9.3 33.8 31.3 33.8zM432 305.5v49c-13.3 7.3-30.5 9.8-45.5 9.8-53.5 0-59.8-42.2-59.8-85.7v-87.7h0.5v-1c-7 0-7.3-1.6-24 1v-47.5h24c0-22.3 0.3-31-1.5-41.2h56.7c-2 13.8-1.5 27.5-1.5 41.2h51v47.5s-19.3-1-51-1v91.1c0 14.8 3.3 32.8 21.8 32.8 9.8 0 21.3-2.8 29.3-8.3zM286 68.7c0 18.7-14.5 36.2-33.8 36.2-19.8 0-34.5-17.2-34.5-36.2 0-19.3 14.5-36.7 34.5-36.7 19.8 0 33.8 18 33.8 36.7zM279.8 143.2c-1.8 14.6-1.6 199.8 0 217.8h-55.5c1.6-18.1 1.8-203 0-217.8h55.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/git.js
// module id = null
// module chunks = 